import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '../src/app.module';
import { initializeMsal } from '../src/services/msal';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

initializeMsal().then(() => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});
